import { boardList } from "@/mocks/guaNews";

export default function HotBoard() {
  const top3 = boardList.slice(0, 3);
  const rest = boardList.slice(3);

  const rankColor = (rank: number, up: boolean) => {
    if (rank === 1) return "bg-primary-500 text-background-50";
    if (rank === 2) return "bg-accent-500 text-foreground-950";
    if (rank === 3) return "bg-secondary-500 text-background-50";
    return "bg-background-200 text-foreground-600";
  };

  return (
    <section id="board" className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h4 className="text-sm font-semibold text-accent-700">
            <a href="#board" className="inline-flex items-center gap-1.5">
              <i className="ri-fire-fill text-base"></i>
              Today's Trend
            </a>
          </h4>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日热搜爆料榜</h2>
          <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
            全网讨论热度实时排序，帮你快速定位今天最值得吃透的瓜，点开即看来龙去脉。
          </p>
        </div>
        <a
          href="#flash"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-600 md:inline-flex"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="mt-7 grid gap-5 lg:grid-cols-2">
        {/* top 3 featured */}
        <div className="space-y-3">
          {top3.map((item) => (
            <a
              key={item.rank}
              href="#flash"
              className="group flex items-start gap-4 rounded-lg bg-background-100 p-4 transition-colors hover:bg-background-200/70"
            >
              <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-sm font-black ${rankColor(item.rank, item.up)}`}>
                {item.rank}
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex flex-wrap items-center gap-2">
                  {item.group && (
                    <span className="rounded bg-primary-500 px-1.5 py-0.5 text-[10px] font-bold text-background-50">{item.group}</span>
                  )}
                  <span className="whitespace-nowrap rounded-full bg-background-50 px-2 py-0.5 text-[11px] text-foreground-600 ring-1 ring-inset ring-background-200">
                    {item.tag}
                  </span>
                </span>
                <h3 className="mt-1.5 text-[15px] font-semibold leading-6 text-foreground-950 group-hover:text-primary-700">
                  {item.title}
                </h3>
                <span className="mt-1.5 flex items-center gap-1 text-xs text-foreground-500">
                  <i className={`${item.up ? "ri-arrow-up-line text-accent-600" : "ri-arrow-down-line text-secondary-600"} text-sm`}></i>
                  热度 {item.heat}
                </span>
              </span>
            </a>
          ))}
        </div>

        {/* rest list */}
        <div className="divide-y divide-background-200/70 rounded-lg bg-background-100 ring-1 ring-inset ring-background-200/60">
          {rest.map((item) => (
            <a key={item.rank} href="#flash" className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-200/60">
              <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-[11px] font-bold ${rankColor(item.rank, item.up)}`}>
                {item.rank}
              </span>
              <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                {item.title}
              </span>
              <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                <i className={`${item.up ? "ri-arrow-up-line text-accent-600" : "ri-arrow-down-line text-secondary-600"}`}></i>
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}